import React from 'react'
import {Spin} from "antd";
import './style.css';
import {resultInterface} from "./scannerComp";

const ResultLabel = (props: {
    result: resultInterface,
    loading: boolean
}) => {
    const { result, loading } = props;

    if (loading) {
        return <div className="loading"><Spin size="default" /></div>;
    }

    return (
        <div>
            <h2 style={{fontSize: '30px', margin: '20px'}}>{result.category?.toUpperCase()}</h2>
        </div>
    )
}

export default ResultLabel
